import React from 'react';
import PropTypes from 'prop-types';
import { If, Else, Then } from 'react-if';

import { Link } from '@nerdwallet/currency/components/Link';
import { Stack } from '@nerdwallet/currency/components/Stack';
import { Text } from '@nerdwallet/currency/components/Text';
import classes from '@nerdwallet/base-styles/classes';

/**
 * A display wrapper around individual Manage Accounts sections for consistent display
 */
const ManageAccountsSection = ({
  children,
  inactiveCtaLabel,
  inactiveCtaOnClick,
  inactiveCtaRef,
  isActivated,
  title,
}) => (
  <div className={classes('margin-bottom-4')}>
    <Stack spacing={3}>
      <Text size="large" bold>
        {title}
      </Text>
      <If condition={isActivated}>
        <Then>{children}</Then>
        <Else>
          <Link onClick={inactiveCtaOnClick} ref={inactiveCtaRef}>
            {inactiveCtaLabel}
          </Link>
        </Else>
      </If>
    </Stack>
  </div>
);

ManageAccountsSection.propTypes = {
  children: PropTypes.node.isRequired,
  inactiveCtaLabel: PropTypes.string.isRequired,
  inactiveCtaOnClick: PropTypes.func.isRequired,
  inactiveCtaRef: PropTypes.func,
  isActivated: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default ManageAccountsSection;
